export default "__VITE_ASSET__CJczGVcl__"